export default __webpack_public_path__ + "static/N0242-8b7e57813a89cd6e4cc043912db0caea.png";